import { render, staticRenderFns } from "./NewsWidgetItem.vue?vue&type=template&id=112d9211&"
import script from "./NewsWidgetItem.vue?vue&type=script&lang=js&"
export * from "./NewsWidgetItem.vue?vue&type=script&lang=js&"
import style0 from "./NewsWidgetItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports